export class Dge {

    // eslint-disable-next-line max-params
    constructor(
        readonly id: number,
        readonly name: string,
        readonly dgeDescription: string,
        readonly currentState: DgeState,
        readonly url: string,
        readonly alias: string
    ) { }
}

export enum DgeState {

    RUNNING = 'RUNNING',
    STOPPING = 'STOPPING',
    STOPPED = 'STOPPED',
    INTERRUPTED = 'INTERRUPTED',
    UNLINKED = 'UNLINKED'

}